import { AppModule } from '@thoughtspot/blink-context';
import { SessionService } from '@thoughtspot/session-service';
import { shouldNotShowGlobalBanner } from './routes-util';

export const isLeftPanelVisible = (
    isOverlayPanel: boolean,
    isGlobalNavHidden: boolean,
    isNavigationV3Enabled: boolean,
    isInsightsPage: boolean,
    sessionService: SessionService,
    appModule?: AppModule,
) => {
    // When Nav V3 is enabled and primaryNavHidden is set, only the Data
    // module keeps its sidebar visible — all other modules hide it.
    if (
        appModule === AppModule.Data &&
        isNavigationV3Enabled &&
        isGlobalNavHidden &&
        !isOverlayPanel
    ) {
        return true;
    }

    return (
        !isOverlayPanel &&
        !isGlobalNavHidden &&
        !(
            sessionService.hideHomepageLeftNav(isNavigationV3Enabled) &&
            isInsightsPage
        )
    );
};

export const isGlobalBannerVisible = (
    pathname: string,
    isTrialVersionEnabled: boolean,
    isSlackBotEnabled: boolean,
    isServiceWorkerEnabled: boolean,
) => {
    return (
        !shouldNotShowGlobalBanner(pathname) &&
        (isTrialVersionEnabled || isSlackBotEnabled || isServiceWorkerEnabled)
    );
};
